
import TitleBox from '@/components/CSS/TitleBox'
import certifyBox from '../realPerson/aliCertify'
import { mapGetters } from 'vuex'
import { loadScript } from '@/utils/validate'
import { UPLOAD_PRIVATE_TYPE } from '@/enum/uploadType'

export default {
	components: {
		TitleBox,
		certifyBox
	},
	data() {
		return {
			redirect: '',
			centerDialogVisible: false,
			metaInfo: null,
			userCertifyData: {},
			dialogAliVisible: false,
			dialogVisible: false,
			underAgeDialogVisible: false,
			ruleFrom: {
				realName: null,
				num: null,
				isBack: false,
				returnUrl: process.env.ENV_AUTH_RETRUN_URL
			},
			ossData: {
				accessKeyId: null,
				accessKeySecret: null,
				bucket: null,
				region: null,
				stsToken: null
			},
			rules: {
				realName: [{ required: true, message: '请输入真实姓名', trigger: 'blur' }]
			},
			UPLOAD_PRIVATE_TYPE
		}
	},
	watch: {
		$route: {
			handler(route) {
				this.redirect = route.query && route.query.redirect
			},
			immediate: true
		}
	},
	computed: {
		...mapGetters({ userinfo: 'user/userinfo' }),
		titleBoxLeftImg() {
			if (this.userinfo) {
				return this.userinfo.isRealName ? 'https://oss.pzds.com/imgv2/shiming_icon.png' : 'https://oss.pzds.com/imgv2/userinfo_me.png'
			} else {
				return 'https://oss.pzds.com/imgv2/userinfo_me.png'
			}
		}
	},
	methods: {
		// 倒计时10分钟或认证成功结果
		closeRealNameHandler(certifyId) {
			this.dialogAliVisible = false
			if (certifyId) {
				this.$router.push('/account/realNameStatus?certifyId=' + certifyId)
			}
		},
		getIdCardData(v) {
			if (v.num) {
				this.ruleFrom.num = v.num
			}
			if (v.name) {
				this.ruleFrom.realName = v.name
			}
			if (!v.isBack) {
				this.$refs.backImg.clearBack()
			}
			this.ruleFrom.isBack = v.isBack
		},
		closeDialog() {
			this.submitLoading = false
		},
		back() {
			this.$router.go(-1)
		},
		onSubmitForm() {
			this.$refs['ruleForm'].validate(valid => {
				if (valid) {
					let id = /^[1-9][0-9]{5}(19|20)[0-9]{2}((01|03|05|07|08|10|12)(0[1-9]|[1-2][0-9]|3[0-1])|(04|06|09|11)(0[1-9]|[1-2][0-9]|30)|02(0[1-9]|[1-2][0-9]))[0-9]{3}([0-9]|x|X)$/
					if (!id.test(this.ruleFrom.num)) {
						this.$message.error('身份证识别有误，请重新上传清晰的身份证正反面照')
						return false
					}
					// 获取支付宝二维码
					// this.userCertifyData ={
					//     metaInfo: JSON.stringify(this.metaInfo),
					//     realName: this.ruleFrom.realName,
					//     returnUrl: this.ruleFrom.returnUrl
					// }
					// const p = {
					//     action: this.userCertifyData
					// }

					// this.$api.userCertify(p).then(({ success, info }) => {
					//     if (!success) {
					//         this.$message.error(info)
					//     } else {
					//         this.dialogAliVisible = true
					//         this.dialogVisible = false
					//     }
					// })
					this.$router.push({
						path: '/account/faceCode',
						query: { metaInfo: JSON.stringify(this.metaInfo), realName: this.ruleFrom.realName, returnUrl: this.ruleFrom.returnUrl, redirect: this.redirect }
					})
				}
			})
		},
		onSubmit() {
			if (!this.ruleFrom.num) {
				this.$message.warning('请上传身份证人像面')
				return
			}
			if (!this.ruleFrom.isBack) {
				this.$message.warning('请上传身份证国徽面')
				return
			}

			this.dialogVisible = true
		}
	},
	mounted() {
		this.$store.dispatch('user/UserGetInfo')
		// this.$store.dispatch('AppGetOssAuth')
		const url = 'https://cn-shanghai-aliyun-cloudauth.oss-cn-shanghai.aliyuncs.com/web_sdk_js/jsvm_all.js'
		loadScript('js', url).then(() => {
			this.metaInfo = getMetaInfo()
		})
	}
}
